import { render, staticRenderFns } from "./FadeTransition.vue?vue&type=template&id=596b585e&scoped=true&"
import script from "./FadeTransition.vue?vue&type=script&lang=ts&"
export * from "./FadeTransition.vue?vue&type=script&lang=ts&"
import style0 from "./FadeTransition.vue?vue&type=style&index=0&id=596b585e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596b585e",
  null
  
)

export default component.exports